module.exports = __webpack_public_path__ + "img/2-5.31d470b8.svg";